import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import {
  CLEAR_DRIVER_TASK_SUMMARY,
  FLAG_GETTING_DRIVER_TASK_SUMMARY_MONTHLY,
  FLAG_GETTING_DRIVER_TASK_SUMMARY_MOVEMENTS,
  GET_DRIVER_TASK_SUMMARY_MONTHLY,
  GET_DRIVER_TASK_SUMMARY_MOVEMENTS,
} from '../types';
import { DRIVER_TASK_SUMMARY_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';

const flagGettingDriverTaskSummaryMovements = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DRIVER_TASK_SUMMARY_MOVEMENTS,
    payload: flag,
  });

const flagGettingDriverTaskSummaryMonthly = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_DRIVER_TASK_SUMMARY_MONTHLY,
    payload: flag,
  });

const getDriverTaskSummaryMovements = (query) => async (dispatch) => {
  try {
    dispatch(flagGettingDriverTaskSummaryMovements(true));

    const url = `${DRIVER_TASK_SUMMARY_ENDPOINT}/movements?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const movements = await response.json();

    dispatch({
      type: GET_DRIVER_TASK_SUMMARY_MOVEMENTS,
      payload: movements,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingDriverTaskSummaryMovements(false));
  }
};

const getDriverTaskSummaryMonthly = (query) => async (dispatch) => {
  try {
    dispatch(flagGettingDriverTaskSummaryMonthly(true));

    const url = `${DRIVER_TASK_SUMMARY_ENDPOINT}/monthly?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const monthly = await response.json();

    dispatch({
      type: GET_DRIVER_TASK_SUMMARY_MONTHLY,
      payload: monthly.content,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingDriverTaskSummaryMonthly(false));
  }
};

const clearDriverTaskSummary = () => (dispatch) =>
  dispatch({
    type: CLEAR_DRIVER_TASK_SUMMARY,
  });

const exportDriverTaskSummaryMonthly = (query) => async (dispatch) => {
  try {
    dispatch(flagGettingDriverTaskSummaryMonthly(true));

    const url = `${DRIVER_TASK_SUMMARY_ENDPOINT}/monthly/export?${QueryString.stringify(
      query,
    )}`;

    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'resumen_tareo.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(downloadUrl);
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingDriverTaskSummaryMonthly(false));
  }
};

export {
  flagGettingDriverTaskSummaryMovements,
  flagGettingDriverTaskSummaryMonthly,
  getDriverTaskSummaryMovements,
  getDriverTaskSummaryMonthly,
  clearDriverTaskSummary,
  exportDriverTaskSummaryMonthly,
};